var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWriteJournal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 121,
    viewBox: "0 0 120 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2003_844)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.4848 109.294C36.7272 113.446 36.1514 120.203 43.5157 120.203H72.4727C80.1649 120.203 86.7007 115.248 89.0594 108.353C93.0909 97.7788 45.9192 93.5769 38.4848 109.294Z",
    fill: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9849 109.294C68.1818 98.9687 47.7115 3.395 18.2133 12.0528C11.3187 14.4116 6.36353 20.9474 6.36353 28.6395V102.676C6.36353 112.356 14.2109 120.203 23.8908 120.203H43.5157C40.0669 117.281 40.3024 111.908 43.9849 109.294Z",
    fill: "#C3C3F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.909 91.7668V18.3849L88.1817 12.9303L82.7273 0.203064H43.9809C32.0283 0.203064 30 9.09291 30 15.2898V94.2071C30 100.405 30.627 109.294 43.9809 109.294H83.3819C93.0635 109.294 100.909 101.445 100.909 91.7668Z",
    fill: "#F6F4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.788 94.2072V15.2898C36.788 9.09268 39.6213 3.60197 43.9812 0.203064H34.8C25.1182 0.203064 17.2727 8.05252 17.2727 17.7303V91.7668C17.2727 101.447 25.1201 109.294 34.8 109.294H43.9809C39.6215 105.895 36.788 100.405 36.788 94.2072Z",
    fill: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.909 18.3849H91.4301C86.6228 18.3849 82.7271 14.4892 82.7271 9.68189V0.203064L100.909 18.3849Z",
    fill: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.572 58.2926C113.984 59.7043 113.998 62.0105 112.572 63.4369C111.155 64.8542 99.2093 76.7998 97.1442 78.8649C95.7237 80.2831 93.4205 80.2831 91.9999 78.8649C90.5962 77.4589 90.5817 75.1897 91.9563 73.7668L90 71.799L105.516 56.4854L107.474 58.2491C108.897 56.8744 111.166 56.8892 112.572 58.2926Z",
    fill: "#7320DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9091 45.6575C61.9132 45.6575 62.7274 44.8435 62.7274 43.8392C62.7274 42.8352 61.9134 42.021 60.9091 42.021H36.788C34.4175 43.2332 34.4175 44.4451 36.788 45.6573L60.9091 45.6575Z",
    fill: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 43.8395C30 44.8435 30.814 45.6578 31.8183 45.6578H36.788V42.0214H31.8183C30.814 42.0212 30 42.8352 30 43.8395Z",
    fill: "#C3C3F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 52.9304H36.788C35.0103 54.1426 35.0103 55.3545 36.788 56.5667H90C91.0041 56.5667 91.8183 55.7527 91.8183 54.7484C91.8183 53.7444 91.0041 52.9304 90 52.9304Z",
    fill: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8183 52.9304C30.8142 52.9304 30 53.7444 30 54.7487C30 55.7527 30.814 56.5669 31.8183 56.5669H36.788V52.9304H31.8183Z",
    fill: "#C3C3F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0922 67.4757C80.0963 67.4757 80.9105 66.6617 80.9105 65.6574C80.9105 64.6531 80.0965 63.8392 79.0922 63.8392H36.788C34.6332 65.0513 34.6332 66.2633 36.788 67.4755H79.0922V67.4757Z",
    fill: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 65.6577C30 66.662 30.814 67.476 31.8183 67.476H36.788V63.8396H31.8183C30.814 63.8394 30 64.6534 30 65.6577Z",
    fill: "#C3C3F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6326 78.385C70.6367 78.385 71.4509 77.571 71.4509 76.5667C71.4509 75.5624 70.6369 74.7484 69.6326 74.7484H36.788C35.0103 75.9606 35.0103 77.1726 36.788 78.3847L69.6326 78.385Z",
    fill: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 76.5667C30 77.571 30.814 78.385 31.8183 78.385H36.788V74.7486H31.8183C30.814 74.7486 30 75.5624 30 76.5667Z",
    fill: "#C3C3F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.314 97.1872C68.4921 96.1279 71.377 94.3436 73.7454 91.9775L76.5745 89.151C78.9274 85.8036 76.1084 80.4683 72.2128 77.4897C68.7879 76.5667 64.443 81.0097 63.6115 81.8413C61.2431 84.2099 59.4588 87.0972 58.3995 90.2727C56.9477 94.8889 57.0455 98.612 58.6116 99.1C60.086 99.1429 60.7359 98.627 65.314 97.1872Z",
    fill: "#544575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5243 92.3975C61.5837 89.2217 63.368 86.3345 65.7363 83.9661L72.2128 77.4896C69.4334 75.3643 66.1057 74.4383 63.7165 76.2927C63.007 77.0021 61.5884 78.4208 60.8899 79.1192C58.5216 81.4878 56.7373 84.3751 55.6779 87.5507L54.027 92.5035C52.9205 95.8253 55.4335 99.0076 58.6118 99.0997C58.5689 97.6255 59.0845 96.9756 60.5243 92.3975Z",
    fill: "#443866"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.857 69.8638L102.286 63.4372V63.4349C104.077 59.7641 101.302 54.9228 97.5223 52.1807C91.6945 50.0467 83.0013 59.8398 84.5102 65.1927C87.5229 69.0723 92.8936 71.8002 95.857 69.8638Z",
    fill: "#58EA9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5221 52.1801C94.9128 50.2869 91.8249 49.3939 89.4303 50.5787C87.6978 52.3112 85.5127 54.4962 83.0011 57.0078C81.5581 59.5644 82.52 62.6293 84.51 65.1922C89.2711 60.4313 94.0109 55.6916 97.5221 52.1801Z",
    fill: "#14AE5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110 55.723C112.692 53.0309 113.34 49.0679 111.948 45.7618C107.331 41.1446 102.238 42.5947 99.5557 45.2766L94.0732 50.7591L94.2767 55.4255L102.286 63.4346C107.354 58.3679 104.64 61.0777 110 55.723Z",
    fill: "#9747FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.949 45.7618C111.505 44.709 110.857 43.7221 110 42.865C106.436 39.3008 100.678 39.3313 97.1445 42.865L89.4305 50.5789L94.2772 55.4256C97.6944 52.0084 100.498 49.2046 101.991 47.7116C104.673 45.0296 108.635 44.3678 111.949 45.7618Z",
    fill: "#7320DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5746 89.151C78.8907 86.8342 93.0078 72.7138 95.8571 69.8638L87.848 61.8547C83.0014 59.476 66.687 76.2929 68.5632 81.1396L76.5746 89.151Z",
    fill: "#9747FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8479 61.8545L83.0013 57.0078C80.9036 59.1055 65.8471 74.162 63.7164 76.2927L68.5631 81.1393C72.8114 76.891 80.6828 69.0195 87.8479 61.8545Z",
    fill: "#7320DA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2003_844"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white",
    transform: "translate(0 0.203064)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWriteJournal);
export default __webpack_public_path__ + "static/media/write_journal.c1e4cf7c1403165f2003a3ae81a61d81.svg";
export { ForwardRef as ReactComponent };